import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Tabs.scss';
import { TabsContent, tabsContentTagName, tabsTriggerClickEvent, tabsTriggerName, tabsTriggerTagName, } from './components';
export const tabsName = 'Tabs';
export const tabsTagName = 'cell-component-tabs';
export const tabsClickEvent = 'click';
export class Tabs extends Component {
    constructor() {
        super(tabsName);
        this.handleTabsTriggerClick = this.handleTabsTriggerClick.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${tabsTriggerName}.${tabsTriggerClickEvent}`, this.handleTabsTriggerClick);
    }
    handleTabsTriggerClick(data, event) {
        const tabsContentElement = this.querySelector(`${tabsContentTagName}[data-index="${data.index}"]`);
        if (!tabsContentElement) {
            throw new Error(`Could not find tabs content element with index ${data.index}`);
        }
        if (!(tabsContentElement instanceof TabsContent)) {
            throw new Error('Tabs content element is not an instance of TabsContent');
        }
        this.setAllTabsTriggersInactive();
        this.setAllTabsContentsInactive();
        // TODO: Make this more type safe.
        event.target.setActive();
        tabsContentElement.setActive();
    }
    get tabsTriggerElements() {
        return this.querySelectorAll(tabsTriggerTagName);
    }
    setAllTabsTriggersInactive() {
        this.tabsTriggerElements.forEach((tabsTriggerElement) => {
            tabsTriggerElement.setInactive();
        });
    }
    get tabsContentElements() {
        return this.querySelectorAll(tabsContentTagName);
    }
    setAllTabsContentsInactive() {
        this.tabsContentElements.forEach((tabsContentElement) => {
            tabsContentElement.setInactive();
        });
    }
}
defineComponent(tabsTagName, Tabs);
